module.exports = function(app) {
    app.directive('prescriptsFaqs', function() {

        return {
            restrict: 'A',
            replace: true,
            /*template: require('directives/prescriptsFaqs.html'),*/
            templateUrl: 'prescriptions.appTemplate.html/chmhom/directives/prescriptsFaqs',
            // scope: {},
            controller: ['$scope',
                function($scope) {
                    var showFAQs = $scope.directiveOptions.showFAQs;

                    
                    $scope.uiModules.FAQs = {
                        // FAQs -------------------------------------
                        theTitle: "MBR_PRESCRIPTION_FAQ_HEADLINE",
                        theText: "MBR_PRESCRIPTION_FAQ_TEXT",
                        theURL: "MBR_PRESCRIPTION_FAQ_LINK",
                        theURLTEXT: 'MBR_PRESCRIPTION_FAQ_LINKTEXT',
                        theText2Top:'MBR_PRESCRIPTION_FAQ_TEXT2TOP',
                        theText2Bottom: 'MBR_PRESCRIPTION_FAQ_TEXT2BOTTOM',
                        theURL2: 'MBR_PRESCRIPTION_FAQ_LINK2',
                        theUrlText2: 'MBR_PRESCRIPTION_FAQ_LINKTEXT2',
                        theText2:'MBR_PRESCRIPTION_FAQ_TEXT2',
                        hasBlueBackground: false,
                        // rightSortOrder: 2,
                        isAct207Module: false,
                        isFormsAndActions: false,
                        isGenericModule: showFAQs,
                        isFAQBottom: true
                    }
                }
            ]
        };
    });
}